(() => {
  const selector = '[data-ech]';

  function buildCurve(root) {
    const curve = root.querySelector('[data-ech-curve]');
    if (!curve || curve.dataset.echCurveReady === 'true') return;

    const text = curve.dataset.text || '';
    if (!text.trim()) return;

    const fragment = document.createDocumentFragment();
    const characters = Array.from(text);
    const finalAngle = 24;
    const firstAngle = -24;
    const divisor = Math.max(characters.length - 1, 1);

    characters.forEach((character, index) => {
      const span = document.createElement('span');
      const angle = firstAngle + ((finalAngle - firstAngle) * index) / divisor;
      span.className = 'ech__curve-char';
      span.setAttribute('aria-hidden', 'true');
      span.textContent = character === ' ' ? '\u00a0' : character;
      span.style.setProperty('--ech-char-index', index);
      span.style.transform = `translateX(-0.5em) rotate(${angle}deg)`;
      fragment.appendChild(span);
    });

    curve.appendChild(fragment);
    curve.classList.add('is-curved');
    curve.dataset.echCurveReady = 'true';
  }

  function reveal(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) return;
        root.classList.add('is-visible');
        observer.disconnect();
      },
      { threshold: 0.15 }
    );

    observer.observe(root);
  }

  function init(root) {
    if (!root || root.dataset.echReady === 'true') return;
    root.dataset.echReady = 'true';
    buildCurve(root);
    reveal(root);
  }

  function boot(scope = document) {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll?.(selector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
